export default __webpack_public_path__ + "static/media/upload-icon-white.b765efb3.svg";